<template>
  <section
    class="app-main"
    :style="appMainStyle"
  >
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
    <!-- 底部组件 -->
    <div v-if="showFooter" class="footer"><Footer :background-color="footerBackgroundColor" /></div>
  </section>
</template>

<script>
import Footer from './Footer.vue'

export default {
  name: 'AppMain',
  components: {
    Footer
  },
  computed: {
    key() {
      return this.$route.path
    },
    showNavbar() {
      // 与 layout 里的显示逻辑保持一致
      return this.$route.name !== 'news_home'
    },
    showFooter() {
      // 仅在首页(news_home)不展示底部 Footer
      return this.$route.name !== 'news_home'
    },
    appMainBackground() {
      return this.$route.name === 'news_home' ? '#ffffff' : '#F7F7F7'
    },
    footerBackgroundColor() {
      // 根据当前路由路径动态设置Footer背景色
      const currentPath = this.$route.path

      // 在这里添加需要白色背景的页面路径
      const whiteBackgroundPages = [
        '/news_home' // 首页
        // 可以根据需要添加更多页面路径
      ]

      // 如果当前页面在白色背景列表中，返回白色，否则返回默认的灰色
      return whiteBackgroundPages.includes(currentPath) ? '#ffffff' : '#E9E9E9'
    },
    appMainStyle() {
      return {
        paddingTop: this.showNavbar ? 'var(--navbar-total-height, 80px)' : '0',
        background: this.appMainBackground
      }
    }
  }
}
</script>

<style scoped>
.app-main {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  box-sizing: border-box;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  background: #F7F7F7;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Webkit浏览器（Chrome、Safari等）隐藏滚动条 */
.app-main::-webkit-scrollbar {
  display: none;
}

.footer {
  width: 100%;
}

</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
